module.exports = __webpack_public_path__ + "img/Frame 1103hrp3.b639f3f6.png";